import _asyncToGenerator from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createSlice } from "@reduxjs/toolkit";
import { EvSearchApi } from "apiclient/api/EvSearchApi";
export var initialStateBase = {
  index: 0,
  pageSize: 0,
  current: undefined,
  prev: undefined,
  next: undefined,
  searchType: undefined,
  searchId: undefined,
  totalCount: 0,
  databaseMask: undefined,
  ddDBpref: undefined,
  ddFieldPref: undefined
};
var initialState = _objectSpread({
  status: "init"
}, initialStateBase);
var searchScrollSlice = createSlice({
  name: "searchscroll",
  initialState: initialState,
  reducers: {
    setSearchScrollState: function setSearchScrollState(state, action) {
      state.status = action.payload.status;
      state.index = action.payload.index;
      state.pageSize = action.payload.pageSize;
      state.current = action.payload.current;
      state.prev = action.payload.prev;
      state.next = action.payload.next;
      state.searchType = action.payload.searchType;
      state.totalCount = action.payload.totalCount;
      state.searchId = action.payload.searchId;
      state.databaseMask = action.payload.databaseMask;
      state.ddDBpref = action.payload.ddDBpref;
      state.ddFieldPref = action.payload.ddFieldPref;
    }
  }
});
var setSearchScrollState = searchScrollSlice.actions.setSearchScrollState;
export { setSearchScrollState };
export var selectSearchScrollState = function selectSearchScrollState(state) {
  return state.searchscroll;
};
export var selectSearchScrollStatus = function selectSearchScrollStatus(state) {
  return state.searchscroll.status;
};
export var selectSearchScrollSearchType = function selectSearchScrollSearchType(state) {
  return state.searchscroll.searchType;
};
export default searchScrollSlice.reducer;

// putting REST call code to get scroll state here for lack of a better place

var searchApi = new EvSearchApi();
export function initSearchScroll(_x, _x2) {
  return _initSearchScroll.apply(this, arguments);
}
function _initSearchScroll() {
  _initSearchScroll = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(query, searchhistory) {
    var searchId, pageSize, index, indexNum, search, databaseMask, searchType, current, prev, next, ddDBpref, ddFieldPref, response, totalCount;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            searchId = query.searchId, pageSize = query.pageSize, index = query.index;
            if (!(!searchId || !searchhistory.entities[searchId])) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", _objectSpread({
              status: "done"
            }, initialStateBase));
          case 3:
            indexNum = parseInt(index);
            search = _objectSpread({}, searchhistory.entities[searchId]);
            databaseMask = search.databasemask;
            searchType = search.searchtype;
            search.offset = indexNum - 1;
            search.pageSize = indexNum === 1 || indexNum === 5000 ? 2 : 3;
            search.fetchNavigator = false;
            if (search.dedupCriterias && search.dedupCriterias.length > 0) {
              ddDBpref = search.dedupCriterias[0].dbPrefQueryString;
              ddFieldPref = search.dedupCriterias[0].fieldPref;
            }

            /** @type{FullTextResults} */
            _context.next = 13;
            return searchApi.getResults(search);
          case 13:
            response = _context.sent;
            totalCount = parseInt(response.docResult.totalResultCount);
            if (indexNum === 1) {
              prev = undefined;
              current = response.docIds.length > 0 ? response.docIds[0] : undefined;
              next = response.docIds.length > 1 ? response.docIds[1] : undefined;
            } else if (indexNum === 5000) {
              prev = response.docIds.length > 0 ? response.docIds[0] : undefined;
              current = response.docIds.length > 1 ? response.docIds[1] : undefined;
              next = undefined;
            } else {
              prev = response.docIds.length > 0 ? response.docIds[0] : undefined;
              current = response.docIds.length > 1 ? response.docIds[1] : undefined;
              next = response.docIds.length > 2 ? response.docIds[2] : undefined;
            }
            return _context.abrupt("return", {
              status: "done",
              index: indexNum,
              pageSize: pageSize,
              current: current,
              prev: prev,
              next: next,
              totalCount: totalCount,
              searchType: searchType,
              searchId: searchId,
              databaseMask: databaseMask,
              ddDBpref: ddDBpref,
              ddFieldPref: ddFieldPref
            });
          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _initSearchScroll.apply(this, arguments);
}